// extracted by mini-css-extract-plugin
export default {"checkbox":"NoticeOfPrivacyPracticeForm_checkbox__wotmv","checkboxContainer":"NoticeOfPrivacyPracticeForm_checkboxContainer__Ik-lX"};